export default {
  IcbLevel1: 'Ngành cấp 1',
  IcbLevel2: 'Ngành cấp 2',
  IcbLevel3: 'Ngành cấp 3',
  IcbLevel4: 'Ngành cấp 4',
  listTitleTable: {
    ICB_NAME: 'NGÀNH',
    CLOSE_INDEX: 'Chỉ số',
    INDEX_CHANGE: 'Thay đổi',
    PERCENT_INDEX_CHANGE: '% Thay đổi',
    TOTAL_MATCH_VOLUME: 'KL Khớp',
    TOTAL_MATCH_VALUE: 'GT Khớp',
    FOREIGN_BUY_VOL_MATCHED: 'KLNN Mua',
    FOREIGN_SELL_VOL_MATCHED: 'KLNN Bán',
    FOREIGN_BUY_VALUE_MATCHED: 'GTNN Mua',
    FOREIGN_SELL_VALUE_MATCHED: 'GTNN Bán',
    FOREIGN_NET_VOLUME: 'KLNN Ròng',
    FOREIGN_NET_VALUE: 'GTNN Ròng',
    TOTAL_DEAL_VOLUME: 'KL Thỏa Thuận',
    TOTAL_DEAL_VALUE: 'GT Thỏa Thuận',
    TOTAL_VOLUME: 'Tổng KL',
    TOTAL_VALUE: 'Tổng GT',
    TOTAL_COMPANY: 'Số công ty',
    PE: 'P/E',
    PB: 'P/B',
    OUT_STANDING_SHARES: 'Số CPLHBQ',
    MARKET_CAP: 'Vốn hóa',
    EPS: 'EPS (TTM)',
    BVPS: 'BVPS (TTM)',
    ROE: 'ROE (TTM)',
    ROA: 'ROA (TTM)',
    EQUITY: '(Vay NH+DH)/ Vốn CSH',
    DE: 'Nợ/ Vốn CSH',
    NIM: 'NIM',
    NPL: 'NPL',
    PERCENT_PRICE_CHANGE_1WEEK: '% 1 Tuần',
    PERCENT_PRICE_CHANGE_2WEEK: '% 2 Tuần',
    PERCENT_PRICE_CHANGE_1MONTH: '% 1 Tháng',
    PERCENT_PRICE_CHANGE_3MONTH: '% 3 Tháng',
    PERCENT_PRICE_CHANGE_6MONTH: '% 6 Tháng',
    PERCENT_PRICE_CHANGE_9MONTH: '% 9 Tháng',
    PERCENT_PRICE_CHANGE_1YEAR: '% 1 Năm',
    PERCENT_PRICE_CHANGE_YTD: '% YTD',
    AVERAGE_MATCHED_VOLUME_1WEEK: 'KLTB 1 tuần',
    AVERAGE_MATCHED_VOLUME_2WEEK: 'KLTB 2 tuần',
    AVERAGE_MATCHED_VOLUME_1MONTH: 'KLTB 1 tháng',
    AVERAGE_MATCHED_VOLUME_3MONTH: 'KLTB 3 tháng',
  },
  footer:
    'Khối lượng: x 1,000. Giá Trị: x 1,000,000. Mỗi ngành bao gồm tất cả cổ phiếu từ HOSE, HNX và UPCOM. (Dữ liệu Hose realtime được tính toán vào dữ liệu ngành sau 9h15 AM.)',
};
